/**
 * ProfileApi - Fetches current user profile from backend
 * Calls /verascore/profile endpoint which returns user data from session
 *
 * PRIV-20.3: Lender viewing their own profile requires explicit purpose
 * The /profile route allows: member_self_service, support, compliance_audit, break_glass
 * Since lender is viewing their OWN data, use member_self_service
 *
 * Force rebuild: 2026-02-19 3:48 PM
 */

import GetApi from "./GetApi";
import { ProfileApiResponse } from "./Types";

const API_BASE = import.meta.env.VITE_API_URL || '/api';

function ProfileApi(
  onSuccess: (data: ProfileApiResponse) => void,
  onFail: (data: any) => void,
  onReject: (response: string) => void
) {
  return GetApi<ProfileApiResponse>(
    `${API_BASE}/verascore/profile`,
    onSuccess,
    onFail,
    onReject,
    'member_self_service' // PRIV-20.3: Lender viewing their own profile (self-service)
  );
}

export default ProfileApi;

